import http from '../http';

const privilege = {
    getQuestSetting(filters) {
        return http.get(`/work_order/workOrderTypes/workOrderTypeList`, {params: filters});
    },
    addQuestting(filters) {
        return http.post(`/work_order/workOrderTypes/create`, filters)
    },
    getQuesttingDetail(filters) {
        return http.get(`/work_order/workOrderTypes/getitem`, {params: filters})
    },
    // 修改问题配置
    updateQuestting(filters) {
        return http.post(`/work_order/workOrderTypes/update`, filters)
    },
    delSetting(filters) {
        return http.delete(`/work_order/workOrderTypes/deleteById`, {params: filters})
    },
    getGroupIdByWorkOrderId(filters) {
        return http.get(`/work_order/getGroupIdByWorkOrderId`, {params: filters})
    }
}
export default privilege;
